export const DEFAULT_REGION_ID = 'all';

// Note the match property can be a string or an array, this is used to match region names in the URL
// This gives us a lot of flexibility in how we can match region names in the URL, they can match id, label or match names (we can even include - url encoded names)
export const ALL_AREAS = {
        label: 'All regions',
        id: 'all',
        match: ['all', 'allregions'],
    };

const CENTRAL_LONDON = {
    label: 'Central London',
    id: 'cl',
    match: ['centrallondon', 'cl', 'londoncentral'],
};
const NORTH_LONDON = {
    label: 'North London',
    id: 'nl',
    match: ['northlondon', 'nl', 'londonnorth'],
};
const SOUTH_LONDON = {
    label: 'South London',
    id: 'sl',
    match: ['southlondon', 'sl', 'londonsouth'],
};
const SCOTLAND_NI = {
    label: 'Scotland & Northern Ireland',
    id: 'sni',
    match: ['scotland', 'scot', 'northernireland', 'ni', 'scotlandandnorthernireland', 'scotlandnorthernireland', 'scotlandi'],
};
const NORTH_WEST = {
    label: 'North West',
    id: 'nw',
    match: ['northwest', 'nw', 'northwestregion'],
};
const YORKSHIRE_NORTH_EAST = {
    label: 'Yorkshire & North East',
    id: 'yne',
    match: ['yorkshire', 'northeast', 'ne', 'yorkshireandnortheast', 'yorkshirenortheast'],
};
const EAST_MIDLANDS = {
    label: 'East Midlands',
    id: 'em',
    match: ['eastmidlands', 'em', 'eastmidlandsregion', 'eastmids'],
};
const WEST_MIDLANDS = {
    label: 'West Midlands',
    id: 'wm',
    match: ['westmidlands', 'wm', 'westmidlandsregion', 'westmids'],
};
const SOUTHERN_ENGLAND_WALES = {
    label: 'Southern England & Wales',
    id: 'swa',
    match: ['southernengland', 'wales', 'swa', 'southernenglandwales', 'southernenglandandwales'],
};

export const AREAS_BY_ID = {
    all: ALL_AREAS,
    cl: CENTRAL_LONDON,
    nl: NORTH_LONDON,
    sl: SOUTH_LONDON,
    sni: SCOTLAND_NI,
    nw: NORTH_WEST,
    yne: YORKSHIRE_NORTH_EAST,
    em: EAST_MIDLANDS,
    wm: WEST_MIDLANDS,
    swa: SOUTHERN_ENGLAND_WALES,
};

export const AREAS_BUTTON_ORDER = [
    { label: 'All regions', area: ALL_AREAS },
    { label: 'Central London', area: CENTRAL_LONDON },
    { label: 'North & East London', area: NORTH_LONDON, buttonLabel: <>North &<br />East London</>, },
    { label: 'South London', area: SOUTH_LONDON },
    { label: 'Scotland & Northern Ireland', area: SCOTLAND_NI, buttonLabel: <>Scotland &<br />Northern Ireland</>, },
    { label: 'North West', area: NORTH_WEST },
    { label: 'Yorkshire & North East', area: YORKSHIRE_NORTH_EAST, buttonLabel: <>Yorkshire &<br />North East</>, },
    { label: 'East Midlands', area: EAST_MIDLANDS },
    { label: 'West Midlands', area: WEST_MIDLANDS },
    { label: 'Southern England & Wales', area: SOUTHERN_ENGLAND_WALES, buttonLabel: <>Southern England &<br />Wales</>, },
];

export function findRegionData(search) {
    search = search.toLowerCase();
    // replace - with '' in the search string
    search = search.replace(/-/g, '');
    if (AREAS_BY_ID[search]) {
        return AREAS_BY_ID[search];
    }
    for (const key in AREAS_BY_ID) {
        const region = AREAS_BY_ID[key];
        if (region.match === search) {
            return region;
        }
        if (Array.isArray(region.match)) {
            if (region.match.includes(search)) {
                return region;
            }
        }
        if (region.label === search) {
            return region;
        }
    }
    // Not found
    return null;
}
